import React from "react";
import {
  Package,
  GasPump,
  CurrencyDollar,
  User,
  ChartLine,
  Path,
  Coins,
  ArrowsLeftRight,
} from "@phosphor-icons/react";

export const PackageIcon = () => (
  <Package size={18} weight="duotone" className="text-blue-700" />
);

export const FuelIcon = () => (
  <GasPump size={22} weight="duotone" className="text-orange-600" />
);
export const MoneyIcon = () => (
  <CurrencyDollar size={22} weight="duotone" className="text-emerald-600" />
);
export const DriverIcon = () => (
  <User size={22} weight="duotone" className="text-indigo-600" />
);
export const RpmIcon = () => (
  <ChartLine size={22} weight="duotone" className="text-blue-700" />
);
export const RoutePath = () => (
  <Path size={22} weight="duotone" className="text-slate-700" />
);
export const CoinsIcon = () => (
  <Coins size={22} weight="duotone" className="text-amber-600" />
);
export const CompareIcon = () => (
  <ArrowsLeftRight size={18} weight="bold" />
);
